// Import model
import { FilterRequest } from '../models/FilterRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { FilterCondition } from '../models/FilterCondition';

// Import dependency serializers (for complex types)
import { FilterConditionSerializer } from './FilterConditionSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterRequest instance
   */
  static deserialize(json: string): FilterRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterRequest instance
   */
  static fromObject(obj: any): FilterRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterRequest');
    }


    const instance: FilterRequest = {
      criteria: obj['Criteria'] ? (obj['Criteria'] as any[]).map((item: any) =>
        FilterConditionSerializer.fromObject(item)
      ) : [] as any,
      fields: obj['Fields'] ? (obj['Fields'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      orderBy: obj['OrderBy'] as string | undefined,
      reverseSortOrder: obj['Reverse Sort Order'] as boolean | undefined,
      skip: obj['Skip'] as number | undefined,
      top: obj['Top'] as number | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterRequest instances
   */
  static deserializeArray(json: string): FilterRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterRequest instance to a JSON string
   */
  static serialize(instance: FilterRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterRequest instance to a plain object
   */
  static toObject(instance: FilterRequest): any {
    return {
      'Criteria': instance.criteria?.map((item: any) =>
        FilterConditionSerializer.toObject(item)
      ),
      'Fields': instance.fields?.map((item: any) =>
        item
      ),
      'OrderBy': instance.orderBy,
      'Reverse Sort Order': instance.reverseSortOrder,
      'Skip': instance.skip,
      'Top': instance.top,
    };
  }

  /**
   * Serializes an array of FilterRequest instances to a JSON string
   */
  static serializeArray(instances: FilterRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
